ScoreTrekBattle.Tournament.Team = (function() {
    var _this, CONFIG, STATUS;

    CONFIG = {
        DURATION: 1000,
        Z_INDEX: 999999
    };

    STATUS = {};

    function resetStatus() {
        STATUS = {
            $view: null,
            teamCount: 0,
            dragging: false,
            isMoving: false,
            allowLeaveOuts: false
        };
    }
    resetStatus();

    function render(players, teams) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.renderMulti(['tournament/team/team', 'tournament/team/players', 'tournament/team/player']).then(templates => {
                var $players, $teams, $scrollable;

                STATUS.$view = templates['tournament/team/team'].$view;

                $players = STATUS.$view.find('[data-id="players"]');
                $teams = STATUS.$view.find('[data-id="teams"]');

                players.forEach(participant => {
                    var $player, participantSource;

                    $player = templates['tournament/team/player'].$view.clone();
                    $player.attr('data-participant-id', participant.id);
                    $player.toggleClass('isProPlayer', !!participant.player.pro_account);
                    $player.find('[data-id="name"]').html(`${participant.player.name ? __escapeHTML(participant.player.name) : __i18n('player/deleted')}`);
                    $player.find('[data-id="avatar"]').css('background-image', `url(${participant.player.thumbnail})`);

                    participantSource = getParticipantSource(participant);

                    if (participantSource) {
                        $player.find('[data-id="playerFrom"]').css('display', '').text(participantSource);
                    }

                    $players.append($player);
                });

                for (let i = 0; i < STATUS.teamCount; i++) {
                    $teams.append(renderEmptyTeam(templates['tournament/team/players'].$view.clone()));
                }

                $teams.find('[data-id="teamName"]').each(function(index) {
                    this.textContent = __i18n('dialog/team/name/preset', {teamNumber: getTeamNumber(index + 1, STATUS.teamCount)});
                });

                if (teams && (teams.length > 0)) {
                    setTeams(teams);
                }

                enableDragDrop();

                enableClickSelect();

                resolve();
            });
        });
    }

    function renderEmptyTeam($team) {
        let $teamPlayers, $teamPlayer;

        $teamPlayers = $team.find('[data-id="teamPlayers"]');
        $teamPlayer = $team.find('[data-id="teamPlayer"]');
        $teamPlayer.detach();

        for (let i = 0; i < STATUS.teamSize; i++) {
            $teamPlayers.append($teamPlayer.clone());
        }

        return $team;
    }

    function enableClickSelect() {
        STATUS.$view.find('[data-id="teamPlayer"] > [data-id="bye"]').on('click', function() {
            let $targetTeamPlayer, teamName, items, itemMap;

            $targetTeamPlayer = $(this).closest('[data-id="teamPlayer"]');

            teamName = $targetTeamPlayer.closest('[data-id="team"]').find('[data-id="teamName"]').text().trim();

            items = [];
            itemMap = {};

            STATUS.$view.find('[data-id="players"] > [data-id="player"]').each(function() {
                let playerId, $player, $playerClone, removeClasses;

                $player = $(this);
                $playerClone = $player.clone();

                playerId = $player.attr('data-participant-id');

                removeClasses = [];
                Array.prototype.forEach.call($playerClone.get(0).classList, className => {
                    if (className.startsWith('ui-')) {
                        removeClasses.push(className);
                    }
                });

                $playerClone.removeClass(removeClasses.join(' '));

                itemMap[playerId] = $player;

                items.push({
                    value: playerId,
                    html: $playerClone
                });
            });

            if (items.length === 0) {
                chmDialog.info(__i18n('tournament/team/assign/done'), '', __i18n('button/gotIt'));
                return;
            }

            chmSelect({
                title: __i18n('tournament/team/assign/player', {teamName: teamName}, true),
                items: items,
                isSearchable: true,
                onSelect: function(value) {
                    if (STATUS.isMoving) {
                        return;
                    }

                    STATUS.isMoving = true;

                    movePlayerToTeam(itemMap[value], $targetTeamPlayer).then(() => {
                        STATUS.isMoving = false;
                    });
                }
            });
        });
    }

    function enableDragDrop() {
        let $players, $scrollable;

        $players = STATUS.$view.find('[data-id="players"]');
        $scrollable = STATUS.$view.find('[data-id="scrollable"]').on('scroll', function() {
            if (!STATUS.dragging) {
                updateRelativePosition($scrollable, $players);
            }
        });

        STATUS.$view.find('[data-id="player"]').draggable({
            revert: 'invalid',
            start: function(event, ui) {
                var $this, offsetTop;

                STATUS.dragging = true;

                $this = $(this);
                this.classList.add('isDragged');
                STATUS.$view.find('[data-id="player"]').css('z-index', '');
                this.style.zIndex = CONFIG.Z_INDEX;

                STATUS.$view.find('[data-id="players"], [data-id="teams"]').css('z-index', '');
                $this.closest('[data-id="players"], [data-id="teams"]').css('z-index', CONFIG.Z_INDEX);

                offsetTop = ($this.offset().top - $scrollable.offset().top);
                $scrollable.attr({
                    'data-min-top': (1 - offsetTop - $scrollable.scrollTop()),
                    'data-max-top': ($scrollable.get(0).scrollHeight - $scrollable.scrollTop() - offsetTop - this.offsetHeight),
                    'data-scroll-top': $scrollable.scrollTop()
                });
            },
            drag: function(event, ui) {
                var minTop, maxTop, justifiedTop, initialScrollTop;

                minTop = parseInt($scrollable.attr('data-min-top'), 10);
                maxTop = parseInt($scrollable.attr('data-max-top'), 10);

                initialScrollTop = parseInt($scrollable.attr('data-scroll-top'), 10);
                justifiedTop = (ui.position.top - $scrollable.scrollTop() + initialScrollTop);

                ui.position.top = Math.max(minTop, Math.min(maxTop, justifiedTop));
            },
            stop: function(event, ui) {
                this.classList.remove('isDragged');
                this.style.zIndex = '';

                STATUS.dragging = false;

                updateRelativePosition($scrollable, $players);
            }
        });

        STATUS.$view.find('[data-id="player"]').droppable({
            accept: '[data-id="player"]',
            over: function(event, ui) {
                if (this.classList.contains('isDropped')) {
                    this.classList.add(($(this).closest('[data-id="team"]').is(ui.draggable.closest('[data-id="team"]'))) ? 'allowDrop' : 'willRemove');
                }
            },
            out: function(event, ui) {
                this.classList.remove('allowDrop', 'willRemove');
            },
            drop: function(event, ui) {
                var $draggable, $droppable, $draggableTeamPlayer, $droppableTeamPlayer;
                $draggable = ui.draggable;

                this.classList.remove('allowDrop', 'willRemove');
                $draggable.attr('style', '');

                if (!this.classList.contains('isDropped')) {
                    return;
                }

                $droppable = $(this);

                $draggableTeamPlayer = $draggable.closest('[data-id="teamPlayer"]');
                $droppableTeamPlayer = $droppable.closest('[data-id="teamPlayer"]');

                if ($draggableTeamPlayer.closest('[data-id="team"]').is($droppableTeamPlayer.closest('[data-id="team"]'))) {
                    $draggableTeamPlayer.append($droppable);
                    $droppableTeamPlayer.append($draggable);
                } else {
                    $droppable.after($draggable);
                    STATUS.$view.find('[data-id="players"]').append($droppable);
                    $droppable.removeClass('isDropped');
                }

                $draggable.attr('style', '').addClass('isDropped');

                updateHasPlayer();
            }
        });

        STATUS.$view.find('[data-id="bye"]').droppable({
            accept: '[data-id="player"]',
            over: function(event, ui) {
                this.classList.add('allowDrop');
            },
            out: function(event, ui) {
                this.classList.remove('allowDrop');
            },
            drop: function(event, ui) {
                var $draggable;
                $draggable = ui.draggable;

                this.classList.remove('allowDrop');
                $draggable.attr('style', '').addClass('isDropped');

                $(this).after($draggable);

                updateHasPlayer();
            }
        });

        STATUS.$view.find('[data-id="playersWrapper"]').droppable({
            accept: '[data-id="player"]',
            over: function(event, ui) {
                var $draggable;
                $draggable = ui.draggable;

                if ($draggable.hasClass('isDropped')) {
                    this.classList.add('allowDrop');
                }
            },
            out: function(event, ui) {
                this.classList.remove('allowDrop');
            },
            drop: function(event, ui) {
                var $draggable;
                $draggable = ui.draggable;

                this.classList.remove('allowDrop');
                $draggable.attr('style', '').removeClass('isDropped');

                $(this).find('[data-id="players"]').append($draggable);

                updateHasPlayer();
            }
        });
    }

    function getParticipantSource(participant) {
        let hasGroup;
        if (!participant.prevTournamentId || !participant.prevTournamentPosition) {
            return '';
        }

        hasGroup = (participant.prevTournamentGroupNumber > 0);

        return __i18n(hasGroup ? 'player/groupWinner': 'player/qualificantPosition', {group: __i18n('game/group', {group: participant.prevTournamentGroupNumber}), position: participant.prevTournamentPosition});
    }

    function updateHasPlayer() {
        STATUS.$view.find('[data-id="bye"]').each(function() {
            this.classList.toggle('hasPlayer', ($(this).closest('[data-id="teamPlayer"]').find('[data-id="player"]').length > 0));
        });
    }

    function updateRelativePosition($scrollable, $element) {
        var scrollable, element;
        scrollable = $scrollable.get(0);
        element = $element.get(0);
        if (element.offsetHeight < scrollable.offsetHeight) {
            element.style.marginTop = `${scrollable.scrollTop}px`;
        } else if (element.offsetHeight < (scrollable.offsetHeight + scrollable.scrollTop)) {
            element.style.marginTop = `${Math.min((Math.floor(element.parentNode.offsetHeight - element.offsetHeight) - 2), (scrollable.scrollTop - (element.offsetHeight - scrollable.offsetHeight)))}px`;
        } else {
            element.style.marginTop = '';
        }
    }

    function editTeamName(currentTeamName) {
        return new Promise(function(resolve, reject) {
            chmDialog.prompt({
                title: __i18n('dialog/team/name/title'),
                prompt: __i18n('dialog/team/name/prompt'),
                value: currentTeamName
            }).then(teamName => {
                if (!teamName) {
                    reject();
                    return;
                }
                resolve(teamName);
            }).catch(reject);
        });
    }

    function setTeams(teams) {
        teams.forEach((team, teamIndex) => {
            var $team;

            $team = STATUS.$view.find('[data-id="team"]').eq(teamIndex);

            if ($team.length === 0) {
                return;
            }

            if (team.name) {
                $team.find('[data-id="teamName"]').text(team.name);
            }

            if (team.participants) {
                team.participants.forEach((participant, playerIndex) => {
                    var $player;

                    if (participant && participant.id) {
                        $player = STATUS.$view.find('[data-id="players"]').find(`[data-participant-id="${participant.id}"]`);

                        if ($player.length === 0) {
                            return;
                        }

                        $team.find('[data-id="teamPlayer"]').eq(playerIndex).append($player);
                        $player.addClass('isDropped');
                    }
                });
            }
        });

        updateHasPlayer();
    }

    function getTeamNumber(teamIndex, teamCount) {
        return String(teamIndex).padStart(String(teamCount).length, '0');
    }

    function getTeams() {
        var teams;

        teams = [];

        STATUS.$view.find('[data-id="team"]').each(function() {
            var team, hasPlayers;

            team = {
                id: getTeamId(teams.length + 1),
                name: this.querySelector('[data-id="teamName"]').textContent,
                participants: []
            };

            hasPlayers = false;
            this.querySelectorAll('[data-id="teamPlayer"]').forEach(teamPlayer => {
                var player;
                player = teamPlayer.querySelector('[data-id="player"]');
                hasPlayers = hasPlayers || !!player;
                team.participants.push(player ? player.getAttribute('data-participant-id') : null);
            });

            if (hasPlayers) {
                team.participants.sort((participantA, participantB) => ((participantA === null) ? 1 : 0) - ((participantB === null) ? 1 : 0));
                teams.push(team);
            }
        });

        teams.sort(function(teamA, teamB) {
            return (teamA.name > teamB.name) ? 1 : -1;
        });

        return teams;
    }

    function start() {
        return new Promise(function(resolve, reject) {
            let dialog;

            dialog = chmDialog({
                title: __i18n('tournament/team/assign'),
                content: STATUS.$view,
                large: true,
                paddingTop: false,
                isPersistant: true,
                buttons: [
                    {
                        label: __i18n('button/apply'),
                        primary: true,
                        action: function() {
                            if (!STATUS.allowLeaveOuts && (STATUS.$view.find('[data-id="players"]').children().length > 0)) {
                                chmDialog.info(__i18n('error/PLAYERS_NOT_ALL_ASSIGNED'), null, __i18n('button/gotIt'));
                                return false;
                            }
                            resolve(getTeams());
                        }
                    },
                    {
                        label: __i18n('button/cancel'),
                        action: function() {
                            ScoreTrekBattle.View.confirmDiscardChanges().then(() => {
                                dialog.close();
                                reject();
                            }).catch(ignore => {});

                            return false;
                        }
                    }
                ]
            });
        });
    }

    function shuffleTeams() {
        var $player, $players, $team, bucket;
        
        if (!STATUS.$view || STATUS.isMoving) {
            return;
        }

        STATUS.isMoving = true;

        $players = STATUS.$view.find('[data-id="players"]');
        $player = STATUS.$view.find('[data-id="player"]');
        $team = STATUS.$view.find('[data-id="team"]');

        bucket = [];

        if ($players.children().length === 0) {
            $player.each(function() {
                this.classList.remove('isDropped');
                $players.append(this);
            });
        }

        updateHasPlayer();

        setTimeout(() => {
            let promises;

            $players.find('[data-id="player"]').each(function() {
                var $this;
                $this = $(this);
                bucket.push({
                    $player: $this
                });
            });

            promises = [];

            while (bucket.length > 0) {
                (() => {
                    var bucketItem;

                    bucketItem = bucket.splice(Math.floor(Math.random() * bucket.length), 1).shift();

                    $targetTeamPlayer = $team.find('[data-id="bye"]:not(.hasPlayer)').first().closest('[data-id="teamPlayer"]');

                    promises.push(movePlayerToTeam(bucketItem.$player, $targetTeamPlayer));
                })();
            }

            Promise.all(promises).then(() => {
                STATUS.isMoving = false;
            });

        }, 100);
    }

    function movePlayerToTeam($player, $targetTeamPlayer) {
        return new Promise(resolve => {
            let $bye, sourceOffset, targetOffset;

            $bye = $targetTeamPlayer.find('[data-id="bye"]');

            if (
                $bye.hasClass('hasPlayer')
                ||
                ($player.length === 0)
                ||
                ($player.closest('[data-id="players"]').length === 0)
                ||
                ($targetTeamPlayer.length === 0)
                ||
                ($targetTeamPlayer.attr('data-id') !== 'teamPlayer')
            ) {
                console.warn('Player collision!', $player, $targetTeamPlayer);
                return resolve();
            }


            sourceOffset = $player.offset();

            $bye.addClass('hasPlayer').after($player);

            $player.addClass('isDropped');

            targetOffset = $player.offset();

            $player.css({
                transition: `transform 0ms`,
                transform: `translate(${sourceOffset.left - targetOffset.left}px, ${sourceOffset.top - targetOffset.top}px)`
            });


            setTimeout(() => {
                $player.css({
                    transition: `transform ${CONFIG.DURATION}ms`,
                    transform: 'translate(0px, 0px)'
                });

                setTimeout(() => {
                    $player.css({
                        transition: '',
                        transform: ''
                    });

                    resolve();
                }, CONFIG.DURATION + 100);
            }, 100);
        });
    }

    function getTeamId(teamIndex) {
        return `team_${String(teamIndex).padStart(4, '0')}`;
    }

    _this = {
        assignSinglePlayers: function(allowLeaveOuts, players) {
            return new Promise(function(resolve, reject) {
                var teams;

                resetStatus();

                STATUS.allowLeaveOuts = allowLeaveOuts;

                if (!players || (players.length === 0)) {
                    reject(__i18n('error/NO_PLAYERS'));
                    return;
                }

                teams = [];
                players.forEach(participant => {
                    teams.push({
                        id: getTeamId(teams.length + 1),
                        name: '',
                        participants: [participant.id]
                    });
                });

                resolve(teams);
            });
        },
        assignMultiplePlayers: function(allowLeaveOuts, players, preset, teams) {
            return new Promise(function(resolve, reject) {
                resetStatus();

                STATUS.allowLeaveOuts = allowLeaveOuts;
                STATUS.teamCount = parseInt(preset.preset.playerLimit, 10);
                STATUS.teamSize = parseInt(preset.teamSize, 10);

                if (isNaN(STATUS.teamCount) || (STATUS.teamCount < 1) || ((STATUS.teamCount * STATUS.teamSize) < players.length)) {  
                    reject(__i18n('error/TEAM_COUNT_MISMATCH'));
                    return;
                }

                render(players, teams).then(start).then(resolve).catch(reject).finally(resetStatus);
            });
        }
    };

    ScoreTrekBattle.Event.on('action.teams.shuffle', function() {
        shuffleTeams();
    });

    ScoreTrekBattle.Event.on('action.team.rename', function() {
        var $teamName, $otherTeamNames;

        if (!STATUS.$view) {
            return;
        }

        $teamName = $(this).closest('[data-id="team"]').find('[data-id="teamName"]');
        $otherTeamNames = STATUS.$view.find('[data-id="teamName"]').not($teamName);

        editTeamName($teamName.text()).then(function(teamName) {
            var isUnique;
            isUnique = true;

            teamName = teamName.replace(/  +/g, ' ');

            $otherTeamNames.each(function() {
                isUnique = isUnique && (this.textContent.toLowerCase() !== teamName.toLowerCase());
                return isUnique;
            });

            if (!isUnique) {
                chmDialog.info(__i18n('error/TEAM_NAME_DUPLICATE'), null, __i18n('button/gotIt'));
                return;
            }

            $teamName.text(teamName);
        }).catch(ignore => {});
    });

    return _this;
})();